// extracted by mini-css-extract-plugin
export var headerImage = "Header-module--headerImage--LBe5x";
export var headerBg = "Header-module--headerBg--CGqxm";
export var logo = "Header-module--logo--m5asN";
export var navigationBar = "Header-module--navigationBar--4g5QC";
export var hamburgerMenu = "Header-module--hamburgerMenu--Z1efm";
export var hamburgerContent = "Header-module--hamburgerContent--0ZhN6";